"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { ArrowUp, Instagram, Linkedin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="222022" className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-12">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="flex flex-col gap-4">
            <div className="h-6 w-24 bg-muted/20 animate-pulse rounded-sm" />
            <div className="flex flex-col gap-3 mt-2">
              <div className="h-4 w-full bg-muted/10 animate-pulse rounded-sm" />
              <div className="h-4 w-5/6 bg-muted/10 animate-pulse rounded-sm" />
              <div className="h-4 w-4/6 bg-muted/10 animate-pulse rounded-sm" />
            </div>
          </div>)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    const fallbackColumns = [{
      title: "CONSULTANCY",
      links: [{
        label: "Our Expertise",
        href: "/OurExpertisePage"
      }, {
        label: "Global Operations",
        href: "/GlobalOperationsPage"
      }, {
        label: "The Nova Team",
        href: "/TheNovaTeamPage"
      }, {
        label: "Connect",
        href: "/ConnectPage"
      }]
    }, {
      title: "SOLUTIONS",
      links: [{
        label: "Project Management",
        href: "/OurExpertisePage"
      }, {
        label: "Logistics Planning",
        href: "/OurExpertisePage"
      }, {
        label: "Resource Allocation",
        href: "/OurExpertisePage"
      }, {
        label: "Stakeholder Relations",
        href: "/OurExpertisePage"
      }]
    }, {
      title: "GLOBAL HUBS",
      links: [{
        label: "London Office",
        href: "#"
      }, {
        label: "Dubai Office",
        href: "#"
      }, {
        label: "Singapore Office",
        href: "#"
      }, {
        label: "Contact Global",
        href: "/ConnectPage"
      }]
    }, {
      title: "GOVERNANCE",
      links: [{
        label: "Privacy Policy",
        href: "#"
      }, {
        label: "Terms of Service",
        href: "#"
      }, {
        label: "Compliance",
        href: "#"
      }, {
        label: "Cookie Policy",
        href: "#"
      }]
    }];
    return <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-12">
        {fallbackColumns.map((col, i) => <div key={i} data-index={i} className="flex flex-col gap-5">
            <h4 className="font-default font-bold text-secondary text-xs tracking-widest uppercase">
              {col.title}
            </h4>
            <ul className="flex flex-col gap-3">
              {col.links.map((link, j) => <li key={j} data-index={j}>
                  <Link to={link.href} className="text-sm font-default text-muted-foreground hover:text-primary transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>)}
      </div>;
  }
  return <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-12">
      {menuItems.map((item, i) => <div key={item.id} data-index={i} className="flex flex-col gap-5">
          <h4 className="font-default font-bold text-secondary text-xs tracking-widest uppercase">
            {item.href ? <Link to={item.href} className="hover:text-primary transition-colors">
                {item.label}
              </Link> : item.label}
          </h4>
          {item.children && item.children.length > 0 && <ul className="flex flex-col gap-3">
              {item.children.map((child, j) => <li key={child.id} data-index={j}>
                  <Link to={child.href || "#"} className="text-sm font-default text-muted-foreground hover:text-primary transition-colors duration-200">
                    {child.label}
                  </Link>
                </li>)}
            </ul>}
        </div>)}
    </div>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  const socialLinks = [];
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="dark bg-background text-foreground pt-24 pb-8 relative overflow-hidden border-t border-secondary/20">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        {}
        <div className="flex justify-center mb-20">
          <Link to="/" className="inline-block transition-opacity hover:opacity-90">
            <img src="https://novaprojectmgnt.com/wp-content/uploads/2026/04/NOVA.png" alt="Nova Project Management" className="w-auto object-contain !h-[80px]" />
          </Link>
        </div>

        {}
        <div className="mb-20">
          <MenuProvider menu_id="45">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className="pt-8 border-t border-border/20 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-xs font-mono text-muted-foreground tracking-tight">© 2025&nbsp;NOVA PROJECT MANAGEMENT. GLOBAL LOGISTICS &amp; CONSULTANCY.</p>

          <div className="flex items-center gap-4">
            {socialLinks.map((social, index) => {
            const Icon = social.icon;
            return <Link key={index} data-index={index} to={social.href} aria-label={social.label} className="flex items-center justify-center size-10 rounded-sm border border-border/20 text-muted-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300">
                  <Icon className="size-4" />
                </Link>;
          })}
          </div>
        </div>
      </div>

      {}
      <Button variant="secondary" size="icon" onClick={scrollToTop} className="fixed bottom-8 right-8 z-50 rounded-sm shadow-2xl bg-primary text-primary-foreground hover:scale-105 transition-transform duration-300 border-none" aria-label="Back to top">
        <ArrowUp className="size-5" />
      </Button>
    </section>;
}